import { aawzDate } from '@utils/dates/aawz-date'

const FORMATO_BR = 'DD/MM/YYYY'
const PADRAO_BR = /^\d{1,2}\/\d{1,2}\/\d{4}$/

/**
 * Formata uma data de ativo em DD/MM/YYYY, ou '-' quando ausente/inválida.
 *
 * O backend devolve as datas do ativo em DD/MM/YYYY (`data_vencimento`,
 * `data_aplicacao_inicial`, `data_cotizacao_inicial`, `cupom_inicio`,
 * `amortizacao_inicio`), mas o helper também recebe `Date` e timestamp de
 * outros consumidores — por isso os dois ramos. Sem informar o formato de
 * entrada, `new Date('15/12/2024')` é inválida e `new Date('01/03/2021')` é
 * lida como MM/DD, trocando dia e mês em silêncio.
 *
 * @param {String|Date|Number} value data crua vinda da API
 * @param {Number} [addHours] ajuste de fuso aplicado só ao ramo ISO (data em UTC)
 * @returns {String} data formatada ou '-'
 */
export const formatAssetDate = (value, addHours) => {
  if (!value) {
    return '-'
  }
  const text = typeof value === 'string' ? value.trim() : ''
  if (PADRAO_BR.test(text)) {
    // Formato de exibição: o parse com formato explícito serve só pra VALIDAR
    // (rejeita 31/02); a normalização do zero à esquerda é feita na string.
    // Passar pelo format() traria de volta a assimetria do aawzDate — o
    // parseDate monta meia-noite LOCAL e o formatDate lê getUTC*, então em
    // fuso UTC+ a data voltaria um dia. O addHours só se aplica ao ramo ISO.
    if (!aawzDate(text, FORMATO_BR).isValid()) {
      return '-'
    }
    const [dia, mes, ano] = text.split('/')
    return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`
  }
  const raw = text || value
  if (!aawzDate(raw).isValid()) {
    return '-'
  }
  const parsed = addHours ? aawzDate(raw).add(addHours, 'hours') : aawzDate(raw)
  return parsed.format(FORMATO_BR)
}
